/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100'
      style={{ backgroundImage: `url(${toAbsoluteUrl('/media/misc/bg-auth.png')})` }}>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex justify-content-center justify-content-lg-end align-items-center flex-lg-fill me-lg-20'>

          {/* begin::Wrapper --- DIV INI DIUBAH MENJADI KARTU --- */}
          <div
            className='w-lg-600px' // Kelas asli dipertahankan
            style={{
              padding: '2.5rem 6rem',
              backgroundColor: 'white',
              borderRadius: '3rem', // Menambahkan sudut yang membulat
              boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.08)' // Menambahkan bayangan halus untuk efek 3D
            }}
          >
            {/* Konten Anda dari routing (misalnya, formulir login) akan muncul di sini */}
            <Outlet />
          </div>
          {/* end::Wrapper */}

        </div>
        {/* end::Form */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { AuthLayout }
